import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/Button";
import { Card, CardContent } from "@/components/ui/Card";
import solarHomeImage from "@/res/images/dashboard-solar-home.png";

const promoBenefits = [
  "Lower your electricity bills",
  "Bigger savings over time",
  "Help build a cleaner future",
];

export default function BuyMorePromoCard() {
  return (
    <Card className="relative isolate flex h-full min-h-[266px] flex-col gap-0 overflow-hidden rounded-[14px] border-[#232836] bg-[#12151C] p-0 text-[#D0D0D0] shadow-none">
      <img
        alt=""
        aria-hidden="true"
        className="absolute inset-0 size-full object-cover object-[center_8%] brightness-[1.12] saturate-[1.05]"
        loading="lazy"
        src={solarHomeImage}
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-gradient-to-b from-[#080A0E]/65 via-transparent via-45% to-[#080A0E]/95"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-gradient-to-r from-[#080A0E]/30 via-transparent to-transparent"
      />

      <CardContent className="relative z-10 flex flex-1 flex-col p-3">
        <div className="flex items-start gap-2">
          <div className="grid size-[54px] shrink-0 place-items-center rounded-full border border-[#E9A837] bg-transparent">
            <svg
              aria-hidden="true"
              className="size-[26px] fill-none stroke-[#E9A837]"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.35"
              viewBox="0 0 24 24"
            >
              <path d="M3.5 10.5 12 3.75l8.5 6.75" />
              <path d="M5.5 9.5V20h13V9.5M9 20v-6h6v6" />
              <path d="M8 10.5h8v2.25H8zM10.67 10.5v2.25m2.66-2.25v2.25M8 11.63h8" />
            </svg>
          </div>

          <div className="min-w-0 pt-0.5">
            <h2 className="text-[14px] font-semibold leading-[18px] tracking-[-0.02em] text-white">
              Buy More, Save More
            </h2>
            <p className="mt-1 text-[10px] leading-[13px] text-white/85">
              Grow your SolarCloud system and increase your long-term savings.
            </p>
          </div>
        </div>

        <ul className="mt-auto space-y-1 pb-2 pt-0 text-[11px] font-normal leading-[14px] text-white">
          {promoBenefits.map((benefit) => (
            <li className="flex items-start gap-2" key={benefit}>
              <Check
                aria-hidden="true"
                className="mt-px size-3.5 shrink-0 text-[#76AF26]"
                strokeWidth={2.5}
              />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>

        <Button
          asChild
          className="h-8 w-full rounded-[7px] bg-[#FFB81C] px-3 text-xs font-semibold text-[#080A0E] shadow-none transition-colors hover:bg-[#FFC64D]"
        >
          <Link to="/buypanels">
            Buy more solar
            <ArrowRight aria-hidden="true" className="size-4" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
